import { CircularProgress, Grid, Typography } from '@material-ui/core';
import React from 'react';

function Loader() {
  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justify="center"
      style={{ minHeight: '100vh' }}
    >
      <Grid item align="center">
        <CircularProgress size={60} />
        <Typography style={{ marginTop: '20px' }}>
          Идет загрузка
        </Typography>
      </Grid>
    </Grid>
  );
}

export default Loader;